import { FC } from 'react';

import { Icon } from '@/shared/ui';
import { ButtonProps, ButtonVariant } from '@/shared/ui/Button';
import { Button } from '@/shared/ui/Button/Button';

export const DownloadReceiptButton: FC<ButtonProps> = (props) => {
  return (
    <Button variant={ButtonVariant.GHOST} {...props}>
      <Icon name="download" />
      Квитанція
    </Button>
  );
};
